module.exports = __webpack_public_path__ + "static/img/5.51ffc3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/upload/commonality/20251009/5.jpg
// module id = h7Am
// module chunks = 7